import { h, Host } from "@stencil/core";
import { getUniqueId } from "../../utils/unique-id";
export class Select {
    constructor() {
        this.options = [];
        this.label = "";
        this.labelInfo = "";
        this.selectId = "";
        this.name = "";
        this.disabled = false;
        this.required = false;
        this.error = false;
        this.errorMsg = "";
        this.autocomplete = null;
        this.fullWidth = false;
    }
    selectElement;
    setSelectId() {
        this.selectId = this.selectId || getUniqueId();
    }
    componentWillLoad() {
        this.setSelectId();
        const firstOption = this.selectElement.querySelector("option");
        if (!firstOption) {
            return;
        }
        const optionSelected = this.selectElement.querySelector("option[selected]");
        if (!optionSelected) {
            firstOption.setAttribute("selected", "");
        }
    }
    /**
     * @deprecated use uxChange instead
     * event to set the currently active option value
     */
    changeEventDetail;
    /** event to handle change events from select */
    changeEvent;
    /** function to emit new active option value and selected option */
    /* eslint-disable-next-line */
    selectChange(newValue) {
        this.changeEventDetail.emit(newValue.value);
        this.changeEvent.emit({
            value: newValue.value,
            selectedOption: newValue.options[newValue.selectedIndex]
        });
    }
    render() {
        const { label, labelInfo, selectId, name, disabled, required, error, errorMsg, fullWidth } = this;
        return (h(Host, { key: '0ba57c786dd48307777f52424fadd6d98db1c39b', class: {
                ["ux-select__wrapper"]: true,
                ["ux-select__wrapper--full-width"]: fullWidth
            } }, h("ux-input-label", { key: '47ca32762560edb7791ee028cb15073a12dba975', text: label, labelClasses: "ux-select__wrapper__label", inputId: selectId, error: error, errorMsg: errorMsg, required: required, labelInfo: labelInfo }), h("div", { key: 'a5bd659b89ca74b9ccca61eaf7cae16778a38420', class: `ux-select__wrapper__inner` }, h("div", { key: '393da7443ed6e77315eba227d9b9d0d74278c248', class: {
                [`ux-select`]: true,
                [`ux-select--disabled`]: disabled,
                [`ux-select--error`]: error
            } }, h("ux-icon", { key: '3f6a825bc60e81b3adea71893e7f6a26d0001c2e', class: "ux-select__icon", name: "chevron-down", weight: "bold" }), h("select", { key: '8a8483889223d6d9b68143a5982f45756af3dfa7', class: "ux-select__select", onChange: (e) => this.selectChange(e.target), id: selectId, name: name, disabled: disabled, required: required, "aria-invalid": error ? "true" : "false", autocomplete: this.autocomplete }, this.options.map((option) => (h("option", { selected: !!option.selected, value: option.value, disabled: !!option.disabled }, option.name))), h("slot", { key: 'c87192362a24101bd56122c54db82a446b59d941' }))))));
    }
    static get is() { return "ux-select"; }
    static get originalStyleUrls() {
        return {
            "$": ["select.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["select.css"]
        };
    }
    static get properties() {
        return {
            "options": {
                "type": "unknown",
                "mutable": false,
                "complexType": {
                    "original": "UxOption[]",
                    "resolved": "UxOption[]",
                    "references": {
                        "UxOption": {
                            "location": "import",
                            "path": "./option",
                            "id": "src/components/select/option.ts::UxOption"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "array of options"
                },
                "defaultValue": "[]"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "label text describing the select component field"
                },
                "attribute": "label",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "labelInfo": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "additional info label for the input field"
                },
                "attribute": "label-info",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "selectId": {
                "type": "string",
                "mutable": true,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "select id attribute"
                },
                "attribute": "select-id",
                "reflect": true,
                "defaultValue": "\"\""
            },
            "name": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "name of the select field"
                },
                "attribute": "name",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the select component is disabled"
                },
                "attribute": "disabled",
                "reflect": false,
                "defaultValue": "false"
            },
            "required": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the select component is required"
                },
                "attribute": "required",
                "reflect": false,
                "defaultValue": "false"
            },
            "error": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "indicates if the select component has an error state"
                },
                "attribute": "error",
                "reflect": false,
                "defaultValue": "false"
            },
            "errorMsg": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Error message that is rendered if component has an error"
                },
                "attribute": "error-msg",
                "reflect": false,
                "defaultValue": "\"\""
            },
            "autocomplete": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "autocomplete attribute, will be set on the select element. Refer to HTML standards for allowed values"
                },
                "attribute": "autocomplete",
                "reflect": false,
                "defaultValue": "null"
            },
            "fullWidth": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "will make the select element extend for the full width of the parent element"
                },
                "attribute": "full-width",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get events() {
        return [{
                "method": "changeEventDetail",
                "name": "uxSelectChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [{
                            "name": "deprecated",
                            "text": "use uxChange instead\nevent to set the currently active option value"
                        }],
                    "text": ""
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }, {
                "method": "changeEvent",
                "name": "uxChange",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "event to handle change events from select"
                },
                "complexType": {
                    "original": "{ value: string; selectedOption: HTMLOptionElement }",
                    "resolved": "{ value: string; selectedOption: HTMLOptionElement; }",
                    "references": {
                        "HTMLOptionElement": {
                            "location": "global",
                            "id": "global::HTMLOptionElement"
                        }
                    }
                }
            }];
    }
    static get elementRef() { return "selectElement"; }
    static get watchers() {
        return [{
                "propName": "selectId",
                "methodName": "setSelectId"
            }];
    }
}
//# sourceMappingURL=select.js.map
